import { render, staticRenderFns } from "./saleOffersAnnouncements-add.vue?vue&type=template&id=0c1595f6&"
import script from "./saleOffersAnnouncements-add.vue?vue&type=script&lang=js&"
export * from "./saleOffersAnnouncements-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports